import { jsx as f } from "react/jsx-runtime";
import { forwardRef as N, useState as v, useEffect as x } from "react";
import { c as R } from "./tw-cn-mXgPecoF.mjs";
import { c as b } from "./index-BpNK5r1N.mjs";
const A = b([
  "relative inline-block h-32 w-52 p-2 rounded-full group",
  "transition-colors duration-200 ease-in-out",
  "bg-fill-neutral-weak3 aria-checked:bg-fill-neutral-main",
  "disabled:bg-interaction-neutral-disable-main disabled:cursor-not-allowed disabled:opacity-30",
  "disabled:aria-checked:bg-interaction-neutral-disable-main"
]), D = b([
  "absolute left-2 top-2 size-28 rounded-full bg-static-white shadow-3 ",
  "transition-transform duration-200 ease-in-out group-aria-checked:translate-x-20"
]), I = N((d, m) => {
  const { className: h, style: w, checked: a, disabled: i, onChange: e, onKeyDown: o, onClick: l, ...p } = d, [c, u] = v(a ?? d.defaultChecked ?? !1), k = A(), g = D(), n = (t, r) => {
    if (a !== void 0)
      return e == null || e(t, r), t;
    let s = c;
    return i || (s = t, u(s), e == null || e(s, r)), s;
  }, y = (t) => {
    t.key === "ArrowLeft" ? n(!1, t) : t.key === "ArrowRight" && n(!0, t), o == null || o(t);
  }, S = (t) => {
    const r = n(!c, t);
    l == null || l(r, t);
  };
  return x(() => {
    i || u(!!a);
  }, [a, i]), /* @__PURE__ */ f(
    "button",
    {
      ...p,
      "aria-checked": c,
      className: R(k, h),
      disabled: i,
      onClick: S,
      onKeyDown: y,
      ref: m,
      role: "switch",
      style: w,
      type: "button",
      children: /* @__PURE__ */ f("span", { className: g })
    }
  );
});
I.displayName = "NDS.Switch";
export {
  I as S
};
